import React from 'react';
import { FiInfo, FiLayers } from 'react-icons/fi';

export type ActiveTab = 'details' | number;

interface SubjectLevelTabsProps {
  levelLabels: string[];
  enabledDepth: number;
  activeTab: ActiveTab;
  onSelect: (tab: ActiveTab) => void;
}

const SubjectLevelTabs: React.FC<SubjectLevelTabsProps> = ({
  levelLabels,
  enabledDepth,
  activeTab,
  onSelect,
}) => {
  return (
    <nav className="subject_level_tabs">
      <button
        type="button"
        className={`subject_level_tab ${activeTab === 'details' ? 'active' : ''}`}
        onClick={() => onSelect('details')}
      >
        <FiInfo />
        <span>Details</span>
      </button>

      {levelLabels.map((label, index) => {
        const level = index + 1;
        const disabled = level > enabledDepth;
        return (
          <button
            key={level}
            type="button"
            disabled={disabled}
            title={disabled ? 'This level is disabled' : undefined}
            className={`subject_level_tab ${activeTab === level ? 'active' : ''} ${
              disabled ? 'disabled' : ''
            }`}
            onClick={() => !disabled && onSelect(level)}
          >
            <FiLayers />
            <span className="subject_level_tab_label">
              <span className="subject_level_tab_index">Level {level}</span>
              {label || '—'}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default SubjectLevelTabs;
